module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"notice_title":"[{brand_name} ポイント案内]","new_review_button_label_with_mileage":"レビューを書いて最大 %{expected_mileage}円獲得","new_review_button_label":"レビューを書く","max_mileage":"最大 {0} 獲得可能","no_review_message":"投稿できるレビューがありません。","money":"円"}}')
  delete Component.options._Ctor
}
